<script setup lang="ts">
import { ref } from "vue";

import { shapeKey } from "@/components/injectKeys";
import BaseInput from "@/components/ui/BaseInput/BaseInput.vue";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import type { LabelAlign, Shape } from "@/model/shape";
import { injectStrict } from "@/utils/vue";

const shape = injectStrict(shapeKey);
const dropdown = injectStrict(dropdownKey);

const emit = defineEmits<{ update: [label: Exclude<Shape["label"], undefined>] }>();

const label = ref(
  shape.value!.label ? { ...shape.value!.label } : { text: "", align: "start" as LabelAlign },
);

function setAlign(align: LabelAlign) {
  label.value.align = align;
  emit("update", label.value);
}

function setText() {
  emit("update", label.value);
}
</script>

<template>
  <div class="shape-label">
    <div class="style">
      <IconButton
        variant="outlined"
        icon="align/left"
        :activated="label.align === 'start'"
        @click="setAlign('start')"
      />
      <IconButton
        variant="outlined"
        icon="align/center"
        :activated="label.align === 'center'"
        @click="setAlign('center')"
      />
      <IconButton
        variant="outlined"
        icon="align/right"
        :activated="label.align === 'end'"
        @click="setAlign('end')"
      />
    </div>
    <BaseInput
      v-model="label.text"
      v-autofocus
      control-type="text"
      @keydown.enter.prevent="dropdown.close"
      @blur="setText"
    />
  </div>
</template>

<style lang="scss" scoped>
.shape-label {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.5em;
  width: 250px;

  .style {
    display: flex;
    justify-content: center;
    gap: 0.5em;
  }
}
</style>
